module.exports = "/_next/static/images/slide18-1d044364f0c30d3acba22527bbe4f336.webp";